import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Section, StatCard, IconButton, BottomSheet } from '../../shared/components';
import { useCurrentUser, useSignOut, useAllowedModules } from '../../shared/auth/AuthProvider';
import { resolveEffectiveTurnoGeoModules } from '../../shared/config/turnoGeoModules';
import { ThemeSwitcher } from '../../shared/theme/ThemeSwitcher';
import { MapPinIcon, TimerIcon, SettingsIcon, LogoutIcon, ReportIcon, PaletteIcon } from '../../shared/icons';

/**
 * Home de TurnoGeo - mismo patron que HrHomePage (Gestion Humana): saludo +
 * accesos directos a las pantallas principales de esta aplicacion.
 */
export function TurnoGeoHomePage() {
  const navigate = useNavigate();
  const user = useCurrentUser();
  const signOut = useSignOut();
  const [themeOpen, setThemeOpen] = useState(false);
  const allowedModules = useAllowedModules();
  const effective = useMemo(() => resolveEffectiveTurnoGeoModules(user.role, allowedModules), [user.role, allowedModules]);

  const greeting = useMemo(() => {
    const h = new Date().getHours();
    if (h < 12) return 'Buenos días';
    if (h < 19) return 'Buenas tardes';
    return 'Buenas noches';
  }, []);

  return (
    <div>
      <div className="safe-top flex items-start justify-between px-4 pb-2 pt-5">
        <div>
          <p className="text-sm text-ink-400">{greeting},</p>
          <h1 className="text-2xl font-bold text-ink-900">{user.fullName.split(' ')[0]}</h1>
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <IconButton
            icon={<PaletteIcon width={20} height={20} />}
            label="Tema visual"
            onClick={() => setThemeOpen(true)}
            className="h-11 w-11 text-ink-400 hover:bg-ink-100 hover:text-brand-600"
          />
        {signOut && (
          <IconButton
            icon={<LogoutIcon width={20} height={20} />}
            label="Cerrar sesión"
            onClick={signOut}
            className="h-11 w-11 text-ink-400 hover:bg-ink-100 hover:text-critical"
          />
        )}
        </div>
      </div>

      <BottomSheet open={themeOpen} onClose={() => setThemeOpen(false)} title="Tema visual">
        <div className="pb-2 pt-1">
          <ThemeSwitcher />
        </div>
      </BottomSheet>

      <div className="p-4">
        <Section title="TurnoGeo">
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            <StatCard icon={<MapPinIcon />} label="Registrar entrada o salida" value="Marcar" tone="brand" onClick={() => navigate('/turno-geo/marcar')} />
            <StatCard icon={<TimerIcon />} label="Historial de marcajes" value="Mis Registros" tone="info" onClick={() => navigate('/turno-geo/mis-registros')} />
            <StatCard icon={<ReportIcon />} label="Incapacidades, vacaciones, permisos" value="Novedades" tone="info" onClick={() => navigate('/turno-geo/novedades')} />
            <StatCard icon={<MapPinIcon />} label="Ver y guardar lo que se captura de tu red" value="Registrador" tone="info" onClick={() => navigate('/turno-geo/registrador')} />
            {effective.includes('turnogeo-hours') && <StatCard icon={<TimerIcon />} label="Semanas contra 42 h, extras, recargo nocturno y festivos" value="Horas y recargos" tone="brand" onClick={() => navigate('/turno-geo/horas')} />}
            {effective.includes('turnogeo-settings') && <StatCard icon={<SettingsIcon />} label="Sedes, parámetros y usuarios" value="Configuración" tone="info" onClick={() => navigate('/turno-geo/configuracion')} />}
          </div>
        </Section>
      </div>
    </div>
  );
}
